import initialState from './initialState'
import {FETCH_USERDATA, RECEIVE_USERDATA} from '../actions/actionTypes'

export default function userData(state = initialState.userData, action) {
	let newState
	switch (action.type) {
	case FETCH_USERDATA:
		return {
			...action,
			isFetching: true
		}
	case RECEIVE_USERDATA:
		newState = action.userData
		return {
			...newState,
			isFetching: false
		}
	default:
		return state
	}
}


// WEBPACK FOOTER //
// ./src/redux/reducers/userData.js